export default {"src":"https://d2a42xgzibz9cq.cloudfront.net/_next/static/media/favicon.c7c25eef.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};